import axios from 'axios'
import { getEnv } from 'helper/window-helper'

const api = axios.create({ baseURL: `${getEnv("REACT_APP_API_BACKEND")}` })

export default api